import { z } from "zod";
import { uuidSchema } from "./domain";
import { sitywebRequestSchema } from "./sityweb";

/** The lead detail shows the request, never connector credentials or technical feed state. */
export const leadSitywebRequestDtoSchema = sitywebRequestSchema
  .pick({
    code: true,
    businessName: true,
    category: true,
    location: true,
    description: true,
    photos: true,
    emailVerifiedAt: true,
    createdAt: true,
  })
  .extend({
    requestId: uuidSchema,
    whatsappConfirmedAt: z.string().datetime().nullable(),
  })
  .strict();
export type LeadSitywebRequestDto = z.infer<typeof leadSitywebRequestDtoSchema>;
